<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="radio-group" :class="classProp">
    <div class="radio-option">
      <input
        :id="id"
        type="radio"
        :name="name" 
        :value="value"
        :checked="isChecked"
        :disabled="disabled"
        :aria-describedby="`${id}-help`"
        class="radio-input"
        @change="handleChange($event)"
      />
      <label v-if="label" :for="id" class="radio-label">
        {{ label }}
      </label>
    </div>
    <span
      v-if="validation?.$error && validation?.required?.$invalid"
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ PropName }} is required.
    </span>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    name: { 
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: null,
    },
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    validation: {
      type: Object,
      required: false,
    },
    PropName: {
      type: String,
      default: "Radio Button",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    classProp: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  computed: {
    isChecked() {
      // console.log(
      //   "modelValue:",
      //   this.modelValue,
      //   "value:",
      //   this.value,
      //   "type match:",
      //   typeof this.modelValue === typeof this.value
      // );
      return this.modelValue === this.value; // Strict comparison
    },
  },
  methods: {
    handleChange(event) {
      const newValue = event.target.value; // Emit the selected value directly
      // console.log("Change triggered, newValue:", newValue);
      this.$emit("update:modelValue", this.value); // Emit the prop value
      return newValue;
    },
  },
  mounted() {
   // console.log("RadioVue mounted, id:", this.id, "modelValue:", this.modelValue);
  },
};
</script>

<style lang="scss" scoped>
.radio-group {
  display: inline-block;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.radio-input {
  appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #c0c0bc;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  background-color: #ffffff;
  transition: border-color 0.2s, background-color 0.2s;
  // padding: 10px;
}

.radio-input:checked {
  background-color: #ffffff;
  border: 1px solid #2f847c;
}

.radio-input:checked::after {
  content: "";
  position: absolute;
  width: 8px;
    height: 8px;
    background-color: #2f847c;
    border-radius: 50%;
    margin-left: 3px;
    margin-top: 3px;
}

.radio-input:disabled {
  background-color: #e9ecef;
  border-color: #c0c0bc;
  cursor: not-allowed;
  opacity: 0.6;
}

.radio-label {
  font-family: "Voyado Text", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #21211f;
  cursor: pointer;
}

.radio-label:disabled {
  color: #6c757d;
  cursor: not-allowed;
}

.p-error {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  display: block;
}
</style>